module.exports = function() {
    /*
     * Check if last item has class and add prevent element class
     */
    const checkClassItem = document.querySelector('.grid-cpt__item--before-height');
    if ( checkClassItem ) {
        const prevItem = checkClassItem.previousElementSibling; 

        prevItem.classList.add('grid-cpt__item--height');
    }
    /*
     * //end// Check if last item has class and add prevent element class
     */

    /*
     * Video play/pause on hover item
     */
    const gridItemVideo = document.querySelectorAll('.grid-cpt:not(.grid-cpt--nohover) .grid-cpt__item');

    for(var i=0; i < gridItemVideo.length; i++){
        gridItemVideo[i].addEventListener("mouseover", hoverVideo);
        gridItemVideo[i].addEventListener("mouseleave", hideVideo);

        
        
        if ( gridItemVideo[i].querySelector('video') ) {
            let startTimeVideo = gridItemVideo[i].querySelector('video').getAttribute('data-starttime');
            
            if ( gridItemVideo[i].querySelector('video').hasAttribute('data-starttime') ) {
                gridItemVideo[i].querySelector('video').currentTime = startTimeVideo;
            }

            gridItemVideo[i].querySelector('video').addEventListener("timeupdate", function() {
                if( this.currentTime >= 15 ) {
                    this.currentTime = 0;
                    this.play();
                }
            });
        };

    }
    
    const videoRelated = document.querySelectorAll('.related-single__item');

    for(var i=0; i < videoRelated.length; i++){
        videoRelated[i].addEventListener("mouseover", hoverVideo);
        videoRelated[i].addEventListener("mouseleave", hideVideo);

        
        if( videoRelated[i].querySelector('video') ) {
            let startTimeVideo = videoRelated[i].querySelector('video').getAttribute('data-starttime');

            if ( videoRelated[i].querySelector('video').hasAttribute('data-starttime') ) {
                videoRelated[i].querySelector('video').currentTime = startTimeVideo;
            }
        }

    }

    function hoverVideo() {
        if( this.querySelector('video') ) {
            this.querySelector('video').play();
        }
    }

    function hideVideo() {
        if( this.querySelector('video') ) {
            var video = this.querySelector('video');
            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
            if (isPlaying) {
                video.pause();
            }
        }
    }
    /*
     * //end// Video play/pause on hover item
     */

    /**
     * Video CGI play when is inview
     */
    /*const   videos = document.querySelectorAll('.grid-cpt--nohover .grid-cpt__item');

    let isInViewport = function (elem) {
        const bounding = elem.getBoundingClientRect();
        return (
            bounding.top >= -(window.innerHeight / 2) &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight + (window.innerHeight / 1.5) || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    window.addEventListener('scroll', function (event) {
        for (let index = 0; index < videos.length; index++) {
            if (isInViewport(videos[index])) {
                // console.log('In the viewport!');
                videos[index].querySelector('video').play();
            } else {
                // console.log('Not in the viewport... whomp whomp');
                videos[index].querySelector('video').pause();
            }
        }
    }, false);*/

    /**
     * Popup CGI 
     */
    const   archive =  document.querySelector('.post-type-archive-cgirendering');

    if (archive) {
        window.onload = function() {
            const   video = archive.querySelectorAll('.grid-cpt__item'),
                    popup = document.querySelector('.popup-video'),
                    popupClose = popup.querySelector('.popup-video__close'),
                    popupImage = popup.querySelector('.popup-video__image'),
                    popupVideo = popup.querySelector('.popup-video__video');

            // video.forEach(element => {
            //     element.addEventListener('click', function(){
            //         const videosrc = this.querySelector('.grid-cpt__item__video').getAttribute('src');

            //         popup.classList.add('is-open');
            //         popupVideo.setAttribute('src', videosrc);
            //         popupVideo.onloadeddata = function() {
            //             setTimeout(() => {
            //                 popup.classList.add('is-load');
            //             }, 500);
            //         };
            //     }); 
            // });

            popupClose.addEventListener('click', function() {
                popup.classList.remove('is-open');
                popupVideo.setAttribute('src', '');
                popup.classList.remove('is-load');
                popupImage.setAttribute('src', '');
                popup.classList.remove('has-image');
            });

            popup.addEventListener('click', function() {
                popup.classList.remove('is-open');
                
                setTimeout(() => {
                    popupVideo.setAttribute('src', '');
                    popup.classList.remove('is-load');
                    popup.classList.remove('has-image');
                    popupImage.setAttribute('src', '');
                }, 500);
            });

            document.addEventListener('keydown', function(event) {
                if( popup.classList.contains('is-open') && event.keyCode == 27 ) {
                    popup.classList.remove('is-open');
                    setTimeout(() => {
                        popupVideo.setAttribute('src', '');
                        popup.classList.remove('is-load');
                        popup.classList.remove('has-image');
                        popupImage.setAttribute('src', '');
                    }, 500);
                }
            });
        }
    }
};